import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../window/WindowService';
/** Convert the lodash object into an angular injectable */

@Injectable({
    providedIn: 'root'
})
export class LodashFactory {
    public static $name: string = 'lodash';

    constructor(
        @Inject(WINDOW) private $window: angular.IWindowService
    ) {
        /** Assign a local pointer to the global reference's address */
        let _ = $window['_'];

        /** Remove the global reference so that lodash may ONLY be used by injection. The local reference to the same object is kept */
        delete $window['_'];

        return _;
    }
}
